import React from 'react';
import { reelScenes } from '../../data/reel';
import { useStageScale } from '../../hooks/useStageScale';
import { ClosingScene } from './ClosingScene';
import { FaceScene } from './FaceScene';
import { IsdinScene } from './IsdinScene';
import { KeywordsScene } from './KeywordsScene';
import { MetricsScene } from './MetricsScene';
import { OpeningScene } from './OpeningScene';
import { ParkeoScene } from './ParkeoScene';
import { PencilScene } from './PencilScene';
interface ReelStageProps {
  time: number;
}
const DESIGN_WIDTH = 1920;
export function ReelStage({
  time
}: ReelStageProps) {
  const {
    ref,
    scale
  } = useStageScale(DESIGN_WIDTH);
  const [opening, pencil, isdin, keywords, face, metrics, parkeo, closing] = reelScenes;
  return <div ref={ref} className="relative aspect-video w-full overflow-hidden bg-cream" data-id="element-300" data-mp="3qeoekmmtn7el">
      <p className="sr-only" data-id="element-301" data-mp="2swxqrtfbhy8p">
        I’m David D. Vallejo. I design AI-native products, end-to-end. I help you grow revenue and retention. Work: Pencil, an
        AI canvas, and the ISDIN USA redeem program with –18% drop-off. End-to-End Ownership, AI-Native Design, Design
        Systems, Product Discovery, Cross-functional Leadership. Senior Product Designer, 8+ years in AI, Fintech and
        E-commerce. +20% retention, +15% conversion, +$2.1M impact. Parkeo: registration in 25 seconds, 44% conversion to booking. I own problems end-to-end. Let’s talk.
      </p>
      <div aria-hidden="true" className="absolute left-0 top-0 h-[1080px] w-[1920px] origin-top-left font-sans" style={{
      transform: `scale(${scale})`
    }} data-id="element-302" data-mp="22rlnhkzu49qo">
        <OpeningScene time={time} scene={opening} data-id="element-303" data-mp="1tp2qhhiqcrcc" />
        <PencilScene time={time} scene={pencil} data-id="element-304" data-mp="1tryp782ejk1u" />
        <IsdinScene time={time} scene={isdin} data-id="element-305" data-mp="1orj8q7mtpwfn" />
        <KeywordsScene time={time} scene={keywords} data-id="element-306" data-mp="1osuhymz1fwe5" />
        <FaceScene time={time} scene={face} data-id="element-307" data-mp="3o2u6qzvke9gr" />
        <MetricsScene time={time} scene={metrics} data-id="element-308" data-mp="3o1ss6lfcb4ua" />
        <ParkeoScene time={time} scene={parkeo} data-id="element-309" data-mp="3j5u0anusz4p4" />
        <ClosingScene time={time} scene={closing} data-id="element-310" data-mp="3j2y351qs4k1q" />
      </div>
    </div>;
}